module.exports = __webpack_public_path__ + "static/media/myriad-pharmaceuticals-interaction-design.d340c25f.png";